import type { Appointment, FlagMeta, InsightSection, KpiItem, Provider, StatusMeta } from './types';

// Provider/appointment data comes from the backend; no mock seed.
export const PROVIDERS: Provider[] = [];

export const APPOINTMENTS: Appointment[] = [];

export const STATUS: Record<string, StatusMeta> = {
  CONFIRMED: { label: 'Confirmed', tone: 'success' },
  COMPLETED: { label: 'Completed', tone: 'success-solid' },
  CHECKED_IN: { label: 'Checked in', tone: 'gold' },
  ARRIVED: { label: 'Arrived', tone: 'gold' },
  TREATMENT: { label: 'In treatment', tone: 'info' },
  SCHEDULED: { label: 'Scheduled', tone: 'neutral' },
  PENDING: { label: 'Pending', tone: 'warning' },
  NO_SHOW: { label: 'No show', tone: 'danger' },
  BROKEN: { label: 'Broken', tone: 'danger' },
  RESCHED: { label: 'Rescheduled', tone: 'secondary' },
};

export const FLAGS: Record<string, FlagMeta> = {
  elig_ok: { icon: 'shield-check', tone: 'green', label: 'Eligibility verified' },
  forms_ok: { icon: 'check', tone: 'green', label: 'Forms submitted' },
  confirmed: { icon: 'check', tone: 'green', label: 'Confirmed by patient' },
  reminded: { icon: 'check', tone: 'green', label: 'Reminder acknowledged' },
  all_clear: { icon: 'check', tone: 'green', label: 'All ELVA checks passed' },
  forms_inc: { icon: 'doc', tone: 'yellow', label: 'Forms incomplete' },
  balance: { icon: 'dollar', tone: 'yellow', label: 'Outstanding balance' },
  preauth_p: { icon: 'clock', tone: 'yellow', label: 'Pre-auth pending' },
  anxiety: { icon: 'heart', tone: 'yellow', label: 'Anxiety flag' },
  new_pt: { icon: 'sparkle', tone: 'yellow', label: 'New patient' },
  big_case: { icon: 'crown', tone: 'yellow', label: 'Big case — TC coordinator' },
  unconfirmed: { icon: 'alert', tone: 'red', label: 'Unconfirmed — schedule risk' },
  elig_fail: { icon: 'shield', tone: 'red', label: 'Eligibility failed / inactive' },
  lab_missing: { icon: 'flask', tone: 'red', label: 'Lab not arrived' },
  med_alert: { icon: 'flame', tone: 'red', label: 'Medical alert needs confirmation' },
  birthday: { icon: 'cake', tone: 'ctx', label: 'Birthday today' },
  vip: { icon: 'crown', tone: 'ctx', label: 'VIP / top referrer' },
};

export const FLAG_PRIORITY: string[] = [
  'unconfirmed', 'med_alert', 'elig_fail', 'lab_missing', 'forms_inc', 'balance',
  'preauth_p', 'anxiety', 'new_pt', 'big_case', 'all_clear', 'birthday', 'vip',
];

// KPI rail and insights are sourced from /api/kpi/* and producer outputs; no mock seed.
export const KPIS: KpiItem[] = [];

export const INSIGHTS: InsightSection[] = [];
